import api from '../../api/index'
export default {
  getAdminConfig (context, obj) {
    context.commit('SET_LOADING', { flag: true, message: 'loading_config' })
    return new Promise((resolve, reject) => {
      api.request('get', 'adminconfig/' + obj.i18n.locale, {})
        .then(response => {
          // var data = response.data

          resolve()
          context.commit('SET_LOADING', { flag: false, message: '' })
        })
        .catch(error => {
          console.log(error)
        })
    })
  }
}
export function calculateAspectRatioFit (srcWidth, srcHeight, maxWidth, maxHeight) {
  var ratio = Math.min(maxWidth / srcWidth, maxHeight / srcHeight)
  return { width: srcWidth * ratio, height: srcHeight * ratio }
}
